import React from 'react';
import { getInitials } from 'Helpers/initials';
import { Avatar } from '@life-line-lab/components-react';

import './avatar-title.scss';

interface AvatarTitleProps {
  text: string;
  isLoading?: boolean;
}

const AvatarTitle: React.FC<AvatarTitleProps> = ({ text, isLoading=false }) => {
  return (
    <h3 className="avatar-title">
      {isLoading &&
        <div className="spinner">
          <div className="bouncer"></div>
          <div className="bouncer"></div>
        </div>
      }

      {!isLoading &&
        <React.Fragment>
          <Avatar icon={getInitials(text, true)} shape="square" />
          <span className="title">{text}</span>
        </React.Fragment>
      }
    </h3>
  )
}

export default AvatarTitle;
